/** API diagnostics, for Super Users: the API's health probes and its reference. */
export const diagnosticsPath = '/diagnostics'
